import { memo } from 'react';

import { DetailInfoContainer } from 'containers/components/EntityDetailV2';

const ActivityDetailContainer = memo(({ activity, children, content, icon, noTabs = false }) => {
    const hasActivityOwner = activity.IdActivityOwner && activity.IdActivityOwner !== '-1';

    return (
        <DetailInfoContainer
            avatarId={hasActivityOwner && activity.IdActivityOwner}
            avatarName={activity.ActivityOwner}
            content={content}
            icon={icon}
            noTabs={noTabs}
        >
            {children}
        </DetailInfoContainer>
    );
});

ActivityDetailContainer.displayName = 'ActivityDetailContainer';

export default ActivityDetailContainer;
